import React, { useRef } from 'react'
import {motion , useScroll , useTransform} from 'framer-motion'


function Seperateur({type}) {
    const SepRef = useRef();
    const  {scrollYProgress} = useScroll({
        target:SepRef,
        offset:["start end","end start"]
    })

    const yBg = useTransform(scrollYProgress,[0,1],["-180%","180%"]);

    return(
        <div  ref ={SepRef} className="bg-cover bg-center h-[50vh] min-h-[50rem] w-full overflow-hidden relative pl-[1rem] gap-10 flex items-center justify-center" >
            <motion.div  style={{y:yBg}} className='max-w-[60rem] w-[46rem] text-[5rem] text-center bg-[rgba(158,156,156,0.09)] h-[20%] pt-[4%] pb-[10%] py-[5%] rounded-[2rem]  text-[#7950F2] font-bold shadow-lg shadow-[#222] [-webkit-text-stroke:2px_#333333]'  > {type} </motion.div>

        </div>
    )
}
export default Seperateur
